import { TStoreSlice } from '../storeActivityFilter'

export type TKeywordSlice = {
  keyword: string
  updateKeyword: (newKeyword: string) => void
}

const createKeywordSlice: TStoreSlice<TKeywordSlice> = (set) => ({
  keyword: '',
  updateKeyword: (newKeyword) => {
    set({ keyword: newKeyword })
  },
})

export default createKeywordSlice
